export const actionTypePrefix = '@@USERS';
export const friendsStreamId = '@@USERS_FRIENDS';

//# sourceMappingURL=constants.js.map